import { render, staticRenderFns } from "./TabGraficoComposicaoDoRebanhoMedioPorUa.vue?vue&type=template&id=1f09c744&scoped=true&"
import script from "./TabGraficoComposicaoDoRebanhoMedioPorUa.vue?vue&type=script&lang=js&"
export * from "./TabGraficoComposicaoDoRebanhoMedioPorUa.vue?vue&type=script&lang=js&"
import style0 from "./TabGraficoComposicaoDoRebanhoMedioPorUa.vue?vue&type=style&index=0&id=1f09c744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09c744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VFlex,VTab,VTabItem,VTabs})
